export default {
  credit: {
    PREQUALIFICATION: 'refresh-prequal.twig',
  },
};
